(function () {
  function getHandlingDays() {
    const value = parseInt(document.documentElement.dataset.shippingHandlingDays || '0', 10);
    if (!Number.isFinite(value) || value < 0) return 0;
    return value;
  }

  function getFrenetDays(rate) {
    if (!rate || !Array.isArray(rate.delivery_days) || !rate.delivery_days.length) {
      return null;
    }

    const min = Number(rate.delivery_days[0]);
    const max = Number(rate.delivery_days[1] ?? rate.delivery_days[0]);

    if (!Number.isFinite(min) && !Number.isFinite(max)) {
      return null;
    }

    if (Number.isFinite(min) && Number.isFinite(max)) {
      return Math.max(min, max);
    }

    return Number.isFinite(max) ? max : min;
  }

  function getComparisonDays(rate) {
    if (rate && rate.name === 'Local Delivery') return 1;

    const frenetDays = getFrenetDays(rate);
    if (frenetDays === null) return 999;

    return frenetDays + getHandlingDays();
  }

  function formatDeliveryText(rate, displayName) {
    if (displayName === 'Entrega Motoboy') {
      return '1 dia útil';
    }

    const frenetDays = getFrenetDays(rate);
    if (frenetDays === null) {
      return 'Prazo a consultar';
    }

    const totalDays = frenetDays + getHandlingDays();
    const dayText = totalDays === 1 ? 'dia útil' : 'dias úteis';
    return `Receba em até ${totalDays} ${dayText}`;
  }

  window.ShippingDeliveryDays = {
    getHandlingDays,
    getFrenetDays,
    getComparisonDays,
    formatDeliveryText,
  };
})();
